// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationEnterAddressPath = 'M39 8.9V16H13.5v23H39v7H13.8L5.1 57.5 13.8 69H39v19a5 5 0 01-5 5h-5v7h42v-7h-5a5 5 0 01-5-5V69h25.2V46H61v-7h24.9l8.6-11.5L85.9 16H61V8.9L50 0 39 8.9zM54 69h-8v19c0 1.784-.39 3.478-1.088 5h10.176A11.956 11.956 0 0154 88V69zm7-7h18.2v-9h-62l-3.3 4.5 3.3 4.5H61zM46 39v7h8v-7h-8zm15-7h21.4l3.4-4.5-3.4-4.5H20.5v9H61zm-7-19.8V16h-8v-3.8L50 9l4 3.2z';
var IllustrationEnterAddress = baseIllustration('IllustrationEnterAddress', {
  getPath: () => IllustrationEnterAddressPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationEnterAddress;
//# sourceMappingURL=index.js.map